
import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Gift as GiftIcon, Check, ArrowLeft, QrCode } from 'lucide-react';
import { toast } from '@/hooks/use-toast';

interface QRCodeProps {
  brandName: string;
  amount: number;
  onMarkAsUsed: () => void;
  onBack?: () => void;
}

const QRCode: React.FC<QRCodeProps> = ({ brandName, amount, onMarkAsUsed, onBack }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  
  useEffect(() => {
    console.log("QRCode component mounted with:", { brandName, amount });
  }, [brandName, amount]);

  const handleMarkAsUsed = () => {
    setIsProcessing(true);
    
    // Simulate processing time
    setTimeout(() => {
      onMarkAsUsed();
      toast({
        title: "Success!",
        description: `Your $${amount} ${brandName} GivGo Bucks have been redeemed.`
      });
      setIsProcessing(false);
    }, 800);
  };

  return (
    <div className="flex flex-col items-center max-w-sm mx-auto">
      <Card className="w-full">
        <CardHeader className="text-center">
          <div className="mx-auto w-12 h-12 rounded-full bg-givgo-light flex items-center justify-center text-givgo-purple mb-2">
            <GiftIcon className="h-6 w-6" />
          </div>
          <CardTitle className="text-xl">${amount} {brandName} GivGo Bucks</CardTitle>
          <CardDescription>Scan this QR code at checkout</CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center pb-4">
          <div className="w-48 h-48 bg-gray-200 rounded-lg flex items-center justify-center">
            <div className="border-2 border-givgo-dark w-36 h-36 flex flex-col items-center justify-center p-4">
              <QrCode className="h-24 w-24 mb-2" />
              <span className="text-xs text-muted-foreground text-center">
                GivGo Bucks QR Code
              </span>
            </div>
          </div>
        </CardContent>
        <CardFooter className="flex flex-col space-y-3 pb-6">
          <Button 
            variant="outline" 
            className="flex items-center gap-2 w-full" 
            onClick={handleMarkAsUsed}
            disabled={isProcessing}
          >
            {isProcessing ? (
              <>Processing...</>
            ) : (
              <>
                <Check className="h-4 w-4" /> Mark as Used
              </>
            )}
          </Button>
          {onBack && (
            <Button variant="ghost" className="flex items-center gap-2 w-full" onClick={onBack}>
              <ArrowLeft className="h-4 w-4" /> Back to Market
            </Button>
          )}
        </CardFooter>
      </Card>
    </div>
  );
};

export default QRCode;
